import React, { useState } from "react";
import axios from "axios";
import "./AdminLogin.css";
import logo from "../Components/Header/assets/images/logo.png";
import { NavLink } from "react-router-dom";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        username,
        password,
      });

      localStorage.setItem("token", data.token);
      window.location.href = "/iskconCMS";
    } catch (err) {
      setError(err.response?.data?.message);
    }
  };

  return (
     <div className="admin-login-page">
      
        <NavLink to="/">
          <img
            loading="lazy"
            src={logo}
            alt="Iskcon Vijayawada Logo"
            className="iskcon-loginlogo"
          />
        </NavLink>
      
    <div className="login-container">
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="error">{error}</p>}
        <button type="submit">Login</button>
      </form>
    </div>
    </div>
  );
};

export default AdminLogin;
